import React, { Suspense, useEffect } from 'react';

import Loadingpage from '../Loadingpage';

// Styles
import styles from './index.module.sass';

export default function DigitalMagazine() {
  const digitalCatalog = 'https://viewer.ipaper.io/terramar-brands/revista_de_mes';

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <Suspense fallback={<Loadingpage />}>
      <div className={styles.catalogContainer}>
        <iframe
          title='Terramar Digital Magazine'
          src={digitalCatalog}
          frameborder='0'
          style={{
            width: '100%',
            height: '100%',
          }}
          allow='autoplay; fullscreen;'
          allowfullscreen
          webkitallowfullscreen
          mozallowfullscreen></iframe>
      </div>
    </Suspense>
  );
}
